import React from 'react';
import { Lock, RotateCcw, Zap } from 'lucide-react';
export function MidCTA() {
  return <section className="py-12 md:py-16 bg-[radial-gradient(ellipse_at_center,#1a0e00_0%,#0a0a0a_80%)] border-y border-[rgba(201,151,43,.15)] text-center" data-id="element-219">
      <div className="container" data-id="element-220">
        <img src="https://cdn.magicpatterns.com/uploads/qjYK6WgZBcuzoNyvZFiAEk/Banner_Chekout0.png" alt="Código Oscuro — Solo Hoy $6.36 USD + Bonos Regalo" className="mx-auto mb-8 w-full max-w-[700px] rounded-xl drop-shadow-[0_0_40px_rgba(201,151,43,.35)]" data-id="element-221" />
        <div className="section-label justify-center" data-id="element-222">
          No lo dejes para después
        </div>
        <h3 className="font-playfair text-[clamp(1.5rem,3vw,2.2rem)] text-blanco mb-2.5" data-id="element-223">
          ¿Ya sabes que lo necesitas?
          <br data-id="element-224" />
          No esperes más.
        </h3>
        <p className="text-gris-texto mb-7 text-[.93rem]" data-id="element-225">
          Más de 4.000 personas ya están aplicando estas técnicas. El precio
          sube pronto.
        </p>

        <div className="flex items-center justify-center gap-3.5 mb-7 max-sm:flex-col max-sm:gap-1.5" data-id="element-226">
          <span className="text-[1.2rem] text-rojo-vivo line-through font-semibold" data-id="element-227">
            Valor: $27 USD
          </span>
          <span className="font-playfair text-[2.4rem] font-black text-dorado-claro" data-id="element-228">
            $6.36 USD
          </span>
        </div>

        <p className="text-blanco text-[1.05rem] font-bold mb-3" data-id="element-229">
          ☕ Menos de lo que cuesta un café
        </p>

        <p className="text-blanco text-[1.1rem] font-black uppercase tracking-[.08em] mb-6 animate-pulse" data-id="element-230">
          🔥 Oferta válida hasta hoy
        </p>

        <a href="https://pay.hotmart.com/O105395702C?checkoutMode=10" className="btn-primary animate-shimmer text-[15px] p-[20px_48px] inline-flex items-center justify-center gap-2.5 scale-100 hover:scale-105 transition-transform duration-200" data-id="element-231">
          <Lock className="w-4 h-4" data-id="element-232" /> Acceder ahora con garantía
        </a>

        <div className="flex flex-wrap justify-center gap-3.5 text-xs text-gris-texto mt-5" data-id="element-233">
          <span className="flex items-center gap-1.5" data-id="element-234">
            <Lock className="w-3.5 h-3.5 text-dorado" data-id="element-235" /> Pago seguro
          </span>
          <span className="flex items-center gap-1.5" data-id="element-236">
            <RotateCcw className="w-3.5 h-3.5 text-dorado" data-id="element-237" /> Garantía 7 días
          </span>
          <span className="flex items-center gap-1.5" data-id="element-238">
            <Zap className="w-3.5 h-3.5 text-dorado" data-id="element-239" /> Acceso inmediato
          </span>
        </div>
      </div>
    </section>;
}